import {exeRequest} from '../utils/APIUtils'

export default {
    // DATA
    getProducts : async  () => exeRequest(`/list/produit`, "GET"),
}